











































import FamilyContactButtons from '@/families/components/FamilyContactButtons.vue';
import { EventTypes } from '@/constants/event-type-constants';
import GuardianInfo from '@/families/components/GuardianInfo.vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { LocaleMixin } from '@/locales/locale-mixin';
import type { Family } from '@/families/models/family';
import { FeaturesStore } from '@/features/features-store';
import { CentersStore } from '@/organizations/locations/stores/centers-store';
import { canMakeCenterCalls } from '@/organizations/locations/center-utils';
import { getModule } from 'vuex-module-decorators';

const featureState = getModule(FeaturesStore);
const centersStore = getModule(CentersStore);
@Component({
    components: { FamilyContactButtons, GuardianInfo }
})
export default class GuardiansCard extends Mixins(LocaleMixin) {
    @Prop() family!: Family;

    private viewFamilyEvent = EventTypes.FAMILY_VIEW;
    get isNewTaskModal() {
        return featureState.isNewTaskModal;
    }

    get canMakeCenterCalls(): boolean {
        const centerId = this.family?.primary_guardian?.center_id;
        if (!centerId) {
            return false;
        }
        const center = centersStore.storedAccessibleCenters.find(c => c.id === centerId);
        return canMakeCenterCalls(center);
    }
}
